<template>
  <div class="notifications card text-md" id="tpl_kssChamp_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon icon="fa-xmark"/>
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex">
        <img class="w-12 h-12" src="@/assets/Award.png" alt="">
        <h3>
          <span id="txt_kssChampionNotificationHeader">
            {{ $t('KssChampNotificationComponent.congratulations') }}
          </span>
        </h3>
      </div>
      <div class="break-normal flex">
        <h4 id="tpl_kss_champion_popup_h3">
          {{ $t('KssChampNotificationComponent.youRecievedKssChampAward') }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KssChampNotificationComponent',
  props: ['notification'],
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
  },
};
</script>
